import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { SharepointService } from 'src/app/sunleon/data-access/http/sharepoint-service'
import { SharepointItem } from '../../model/sharepoint-item'
import { environment } from '../../../../environments/environment'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-modal-generation-livrable-sharepoint',
  templateUrl: './modal-generation-livrable-sharepoint.component.html',
  styleUrls: ['./modal-generation-livrable-sharepoint.component.scss']
})
export class ModalGenerationLivrableSharepointComponent implements OnInit {

  driveId = environment.sharepointDriveId
  rootFolderId = environment.simulationFolderId

  items: SharepointItem[] = []
  filteredItems: SharepointItem[] = []

  breadcrumb: { id: string; name: string }[] = []
  currentItemId!: string

  loading = false
  searchTerm = ''
  sortAscending = true

  selectedFolder: SharepointItem | null = null

  creatingFolder = false
  newFolderName = ''

  constructor(
    public activeModal: NgbActiveModal,
    private sharepointService: SharepointService,
    private toastr: ToastrService,

  ) {}

  ngOnInit(): void {
    this.currentItemId = this.rootFolderId
    this.breadcrumb = [{ id: this.rootFolderId, name: 'Simulation' }]
    this.loadChildren(this.currentItemId)
  }

  loadChildren(itemId: string): void {
    this.loading = true
    this.searchTerm = ''
    this.selectedFolder = null

    this.sharepointService
      .getChildren(this.driveId, itemId)
      .subscribe(items => {
        this.items = items.filter(i => i.folder)
        this.applyFilterAndSort()
        this.loading = false
      })
  }

  navigateToBreadcrumb(index: number): void {
    const target = this.breadcrumb[index]
    this.breadcrumb = this.breadcrumb.slice(0, index + 1)
    this.currentItemId = target.id
    this.loadChildren(target.id)
  }

  toggleSort(): void {
    this.sortAscending = !this.sortAscending
    this.applyFilterAndSort()
  }

  applyFilterAndSort(): void {
    const term = this.searchTerm.toLowerCase()

    this.filteredItems = this.items
      .filter(i => i.name.toLowerCase().includes(term))
      .sort((a, b) => {
        const res = a.name.localeCompare(b.name)
        return this.sortAscending ? res : -res
      })
  }

  selectFolder(folder: SharepointItem): void {
    this.selectedFolder = folder
  }

  openFolder(folder: SharepointItem): void {
    this.selectedFolder = null
    this.currentItemId = folder.id
    this.breadcrumb.push({ id: folder.id, name: folder.name })
    this.loadChildren(folder.id)
  }

  confirmSelection(): void {
    if (!this.selectedFolder) return

    this.activeModal.close({
      driveId: this.driveId,
      folderItemId: this.selectedFolder.id,
      folderName: this.selectedFolder.name,
      webUrl: this.selectedFolder.webUrl
    })
  }

  startCreateFolder(): void {
    this.creatingFolder = true
    this.newFolderName = ''
  }

  createFolder(): void {
    const name = this.newFolderName.trim()
    if (!name) return

    if (this.items.some(i => i.name.toLowerCase() === name.toLowerCase())) {
      this.toastr.error('Ce dossier existe déjà')
      return
    }

    this.loading = true

    this.sharepointService
      .createFolder(this.driveId, this.currentItemId, name)
      .subscribe(() => {
        this.creatingFolder = false
        this.newFolderName = ''
        this.loadChildren(this.currentItemId)
      })
  }
}
